var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getWebMcpTools, registerWebMcpTools } from '../base/constant';
import { getUniqueID, isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * Define FileManager's WebMCP tools
 * Each tool includes name, description, input/output schemas, and execution handlers
 */
var webMcpTools = [
    {
        name: 'getSelectedFiles',
        description: 'Retrieve the list of currently selected files and folders in the FileManager. Returns file metadata including IDs, names, types, and paths.',
        inputSchema: {
            type: 'object',
            properties: {},
            required: []
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            id: { type: 'string' },
                            name: { type: 'string' },
                            type: { type: 'string' },
                            size: { type: 'number' },
                            modified: { type: 'string' }
                        }
                    }
                },
                message: { type: 'string' }
            }
        },
        annotations: { readOnlyHint: true }
    },
    {
        name: 'manageFileSystemItems',
        description: 'Create folders, rename files/folders, or delete files/folders by ID. Supports batch operations for deletion.',
        inputSchema: {
            type: 'object',
            properties: {
                action: { type: 'string', enum: ['create', 'rename', 'delete'] },
                name: { type: 'string' },
                id: { type: 'string' },
                ids: { type: 'array', items: { type: 'string' } }
            },
            required: ['action']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: {
                    type: 'object',
                    properties: {
                        action: { type: 'string' },
                        id: { type: 'string' },
                        name: { type: 'string' }
                    }
                },
                message: { type: 'string' }
            }
        },
        annotations: { readOnlyHint: false }
    },
    {
        name: 'manageFileUploadAndDownload',
        description: 'Upload files to the current folder or download/export selected files to local system.',
        inputSchema: {
            type: 'object',
            properties: {
                action: { type: 'string', enum: ['upload', 'download'] },
                ids: { type: 'array', items: { type: 'string' } }
            },
            required: ['action']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: {
                    type: 'object',
                    properties: {
                        action: { type: 'string' },
                        filesProcessed: { type: 'number' },
                        totalSize: { type: 'number' }
                    }
                },
                message: { type: 'string' }
            }
        },
        annotations: { readOnlyHint: false }
    },
    {
        name: 'navigateAndOpenFiles',
        description: 'Navigate backward in folder hierarchy, open files/folders, and refresh file list. Returns current directory state after navigation.',
        inputSchema: {
            type: 'object',
            properties: {
                action: { type: 'string', enum: ['backward', 'openFile', 'refresh'] },
                fileId: { type: 'string' }
            },
            required: ['action']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: {
                    type: 'object',
                    properties: {
                        action: { type: 'string' },
                        currentPath: { type: 'string' },
                        filesCount: { type: 'number' }
                    }
                },
                message: { type: 'string' }
            }
        },
        annotations: { readOnlyHint: true }
    },
    {
        name: 'searchAndFilterFiles',
        description: 'Filter files based on custom criteria (name, type, date, size, etc.). Returns filtered file list matching the specified conditions.',
        inputSchema: {
            type: 'object',
            properties: {
                filterData: { type: 'object' }
            },
            required: []
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: {
                    type: 'object',
                    properties: {
                        filterApplied: { type: 'boolean' },
                        matchCount: { type: 'number' },
                        files: { type: 'array' }
                    }
                },
                message: { type: 'string' }
            }
        },
        annotations: { readOnlyHint: true }
    },
    {
        name: 'manageUserInterface',
        description: 'Enable/disable menu items and toolbar items, close dialogs, refresh layout. Controls UI state for workflow management.',
        inputSchema: {
            type: 'object',
            properties: {
                action: { type: 'string', enum: ['enableMenu', 'disableMenu', 'enableToolbar', 'disableToolbar', 'closeDialog', 'refreshLayout'] },
                items: { type: 'array', items: { type: 'string' } }
            },
            required: ['action']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: {
                    type: 'object',
                    properties: {
                        action: { type: 'string' },
                        itemsAffected: { type: 'number' },
                        items: { type: 'array' }
                    }
                },
                message: { type: 'string' }
            }
        },
        annotations: { readOnlyHint: false }
    },
    {
        name: 'manageSelection',
        description: 'Select all files in current folder or clear the current selection. Prepares files for bulk operations.',
        inputSchema: {
            type: 'object',
            properties: {
                action: { type: 'string', enum: ['selectAll', 'clearSelection'] }
            },
            required: ['action']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: {
                    type: 'object',
                    properties: {
                        action: { type: 'string' },
                        filesSelected: { type: 'number' }
                    }
                },
                message: { type: 'string' }
            }
        },
        annotations: { readOnlyHint: false }
    }
];
/**
 * WebMcpFileManager — Integrates FileManager with the WebMCP protocol.
 * Inject this module via `FileManager.Inject(WebMcpFileManager, …)` to
 * enable AI tool execution; tools are registered automatically on init when
 * `webMcp.enable === true`.
 */
var WebMcpFileManager = /** @class */ (function () {
    function WebMcpFileManager(parent) {
        this.webMcpAbortController = null;
        this.parent = parent;
        this.addEventListener();
        this.tryAutoRegister();
    }
    /**
     * Attaches event listeners for WebMCP communication.
     *
     * @returns {void}
     */
    WebMcpFileManager.prototype.addEventListener = function () {
        this.parent.on(getWebMcpTools, this.getTools, this);
        this.parent.on(registerWebMcpTools, this.registerTools, this);
    };
    /**
     * Removes event listeners when component is destroyed.
     *
     * @returns {void}
     */
    WebMcpFileManager.prototype.removeEventListener = function () {
        if (!this.parent.isDestroyed) {
            this.parent.off(getWebMcpTools, this.getTools);
            this.parent.off(registerWebMcpTools, this.registerTools);
        }
    };
    /**
     * Retrieves available tools, optionally filtered by names.
     *
     * @param {Object} args - The arguments object
     * @param {string[]} args.toolNames - Optional array of tool names to filter
     * @param {WebMcpTool[]} args.tools - Optional array to store filtered tools
     * @returns {WebMcpTool[]} Array of WebMCP tools
     */
    WebMcpFileManager.prototype.getTools = function (args) {
        var toolNames = args.toolNames;
        if (toolNames && toolNames.length !== 0) {
            args.tools = webMcpTools.filter(function (webMcpTool) { return toolNames.indexOf(webMcpTool.name) !== -1; })
                .map(function (webMcpTool) { return (__assign({}, webMcpTool)); });
        }
        else {
            args.tools = webMcpTools.map(function (webMcpTool) { return (__assign({}, webMcpTool)); });
        }
        return args.tools;
    };
    /**
     * Registers tools with document.modelContext for AI access.
     *
     * @param {Object} args - The arguments object
     * @param {string} args.prefix - Optional prefix for tool names
     * @param {string[]|WebMcpTool[]} args.tools - Array of tool names or tool objects
     * @param {string[]} args.exposedTo - Optional array of entities to expose tools to
     * @returns {void}
     */
    WebMcpFileManager.prototype.registerTools = function (args) {
        var _this = this;
        var modelContext = document.modelContext;
        if (!modelContext || typeof modelContext.registerTool !== 'function') {
            return;
        }
        this.webMcpAbortController = new AbortController();
        var toolPrefix = (isNullOrUndefined(args.prefix) ? this.parent.element.id : args.prefix);
        var tools = args.tools && args.tools.length && typeof args.tools[0] === 'object' ? args.tools :
            this.getTools({ toolNames: args.tools });
        tools.forEach(function (tool) {
            tool.name = toolPrefix + "_" + tool.name;
            tool.execute = tool.execute || (function (args) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHandler(tool.name, args || {})];
            }); }); });
            var registerOptions = {
                signal: _this.webMcpAbortController.signal
            };
            if (Array.isArray(args.exposedTo) && args.exposedTo.length > 0) {
                registerOptions.exposedTo = args.exposedTo;
            }
            modelContext.registerTool(tool, registerOptions);
        });
    };
    /**
     * Resolves the registration prefix in priority order:
     *   1. `webMcp.name` — non-empty after trim.
     *   2. `this.parent.element.id` — when present (set by FileManager.preRender).
     *   3. `getUniqueID('filemanager')` — last-resort fallback.
     *
     * @returns {string | null} Resolved prefix, or `null` when no source yields a usable string.
     */
    WebMcpFileManager.prototype.resolveRegistrationPrefix = function () {
        var settingsName = this.parent.webMcpSettings && this.parent.webMcpSettings.name;
        if (typeof settingsName === 'string' && settingsName.trim().length > 0) {
            return settingsName.trim();
        }
        var elementId = this.parent.element && this.parent.element.id;
        if (typeof elementId === 'string' && elementId.length > 0) {
            return elementId;
        }
        return getUniqueID('filemanager');
    };
    /**
     * Attempts to register the default tool set during init when
     * `webMcp.enable === true`. No-op when disabled, when
     * `document.modelContext` is missing, or when prefix resolution fails.
     *
     * @returns {void}
     */
    WebMcpFileManager.prototype.tryAutoRegister = function () {
        if (!this.parent.enableWebMcp) {
            return;
        }
        var settings = this.parent.webMcpSettings;
        var prefix = this.resolveRegistrationPrefix();
        // Invoke our own handler directly so we don't depend on the
        // (now-removed) public `FileManager.registerWebMcpTools` surface.
        // The handlers prefixed with `name_<toolName>` are produced
        // identically against `document.modelContext`.
        this.registerTools({
            prefix: prefix,
            tools: settings.tools,
            exposedTo: settings.exposedTo
        });
    };
    /**
     * Executes a WebMCP tool handler based on command name.
     * Fires beforeWebMcpToolExecute event for cancellation/confirmation.
     *
     * @param {string} command - The command name to execute
     * @param {object} args - The arguments for the command
     * @returns {Promise<WebMcpToolResponse>} Promise that resolves to the tool response
     */
    WebMcpFileManager.prototype.executeHandler = function (command, args) {
        return __awaiter(this, void 0, void 0, function () {
            var lastUnderscore, baseCommand, eventArgs;
            return __generator(this, function (_a) {
                lastUnderscore = command.lastIndexOf('_');
                baseCommand = lastUnderscore >= 0
                    ? command.substring(lastUnderscore + 1)
                    : command;
                eventArgs = { toolName: command, toolArgs: args };
                this.parent.trigger('beforeWebMcpToolExecute', eventArgs);
                // Check if tool execution was cancelled
                if (eventArgs.cancel) {
                    return [2 /*return*/, this.message({
                            action: command,
                            cancelled: true,
                            success: false,
                            message: eventArgs.cancellationResponse ||
                                "[USER_CANCELLED] Tool \"" + command + "\" was cancelled. This is final. Do NOT retry."
                        })];
                }
                // Route to appropriate tool handler
                switch (baseCommand) {
                    case 'getSelectedFiles':
                        return [2 /*return*/, this.handleGetSelectedFiles()];
                    case 'manageFileSystemItems':
                        return [2 /*return*/, this.handleManageFileSystemItems(args)];
                    case 'manageFileUploadAndDownload':
                        return [2 /*return*/, this.handleFileUploadAndDownload(args)];
                    case 'navigateAndOpenFiles':
                        return [2 /*return*/, this.handleNavigateAndOpenFiles(args)];
                    case 'searchAndFilterFiles':
                        return [2 /*return*/, this.handleSearchAndFilterFiles(args)];
                    case 'manageUserInterface':
                        return [2 /*return*/, this.handleUserInterface(args)];
                    case 'manageSelection':
                        return [2 /*return*/, this.handleSelection(args)];
                    default:
                        return [2 /*return*/, this.error("Tool \"" + baseCommand + "\" not found.")];
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Tool Handler: Retrieve currently selected files
     *
     * @returns {WebMcpToolResponse} The response with selected files data
     */
    WebMcpFileManager.prototype.handleGetSelectedFiles = function () {
        try {
            var selectedFiles = this.parent.getSelectedFiles() || [];
            return this.message({
                action: 'getSelectedFiles',
                success: true,
                data: selectedFiles,
                message: "Retrieved " + (selectedFiles.length || 0) + " selected files"
            });
        }
        catch (error) {
            return this.error("Failed to retrieve selected files: " + error.message);
        }
    };
    /**
     * Tool Handler: Manage file system items (create/rename/delete)
     *
     * @param {ManageFileSystemItemsArgs} args - The arguments for the file system operation
     * @returns {WebMcpToolResponse} The response with operation result
     */
    WebMcpFileManager.prototype.handleManageFileSystemItems = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var action, name_1, id, ids, _a, createOutcome, renameOutcome, missingIds, deleteOutcome, error_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 9, , 10]);
                        action = args.action, name_1 = args.name, id = args.id, ids = args.ids;
                        _a = action;
                        switch (_a) {
                            case 'create': return [3 /*break*/, 1];
                            case 'rename': return [3 /*break*/, 3];
                            case 'delete': return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1:
                        if (!name_1 || !name_1.trim()) {
                            return [2 /*return*/, this.error('Create requires a non-empty name')];
                        }
                        if (this.itemNameExists(name_1, true)) {
                            return [2 /*return*/, this.message({
                                    action: 'manageFileSystemItems',
                                    success: false,
                                    data: { action: 'create', name: name_1 },
                                    message: "A file or folder named \"" + name_1 + "\" already exists in the current folder."
                                })];
                        }
                        this.parent.createFolder(name_1);
                        return [4 /*yield*/, this.waitForOperation('create', 2500, name_1)];
                    case 2:
                        createOutcome = _b.sent();
                        if (!createOutcome.success) {
                            return [2 /*return*/, this.message({
                                    action: 'manageFileSystemItems',
                                    success: false,
                                    data: { action: 'create', name: name_1 },
                                    message: createOutcome.message || "Folder \"" + name_1 + "\" was not created."
                                })];
                        }
                        return [2 /*return*/, this.message({
                                action: 'manageFileSystemItems',
                                success: true,
                                data: { action: 'create', name: name_1 },
                                message: "Folder \"" + name_1 + "\" created successfully"
                            })];
                    case 3:
                        if (!id || !name_1) {
                            return [2 /*return*/, this.error('Rename requires both id and name parameters')];
                        }
                        if (this.itemNameExists(name_1, false, id)) {
                            return [2 /*return*/, this.message({
                                    action: 'manageFileSystemItems',
                                    success: false,
                                    data: { action: 'rename', id: id, name: name_1 },
                                    message: "A file or folder named \"" + name_1 + "\" already exists in the current folder."
                                })];
                        }
                        this.parent.renameFile(id, name_1);
                        return [4 /*yield*/, this.waitForOperation('rename', 2500, name_1)];
                    case 4:
                        renameOutcome = _b.sent();
                        if (!renameOutcome.success) {
                            return [2 /*return*/, this.message({
                                    action: 'manageFileSystemItems',
                                    success: false,
                                    data: { action: 'rename', id: id, name: name_1 },
                                    message: renameOutcome.message || "Item \"" + name_1 + "\" was not renamed."
                                })];
                        }
                        return [2 /*return*/, this.message({
                                action: 'manageFileSystemItems',
                                success: true,
                                data: { action: 'rename', id: id, name: name_1 },
                                message: "Item renamed to \"" + name_1 + "\" successfully"
                            })];
                    case 5:
                        if (!ids || !Array.isArray(ids) || ids.length === 0) {
                            return [2 /*return*/, this.error('Delete requires ids array')];
                        }
                        missingIds = ids.filter(function (idValue) { return !_this.itemExistsById(idValue); });
                        if (missingIds.length > 0) {
                            return [2 /*return*/, this.message({
                                    action: 'manageFileSystemItems',
                                    success: false,
                                    data: { action: 'delete', count: ids.length },
                                    message: "Unable to delete missing item id(s): " + missingIds.join(', ')
                                })];
                        }
                        this.parent.deleteFiles(ids);
                        return [4 /*yield*/, this.waitForOperation('delete', 2500, undefined, ids)];
                    case 6:
                        deleteOutcome = _b.sent();
                        if (!deleteOutcome.success) {
                            return [2 /*return*/, this.message({
                                    action: 'manageFileSystemItems',
                                    success: false,
                                    data: { action: 'delete', count: ids.length },
                                    message: deleteOutcome.message || "Delete request for " + ids.length + " item(s) did not complete."
                                })];
                        }
                        return [2 /*return*/, this.message({
                                action: 'manageFileSystemItems',
                                success: true,
                                data: { action: 'delete', count: ids.length },
                                message: "Deleted " + ids.length + " item(s) successfully"
                            })];
                    case 7: return [2 /*return*/, this.error("Unknown action \"" + action + "\" for manageFileSystemItems")];
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        error_1 = _b.sent();
                        return [2 /*return*/, this.error("Failed to manage file system items: " + error_1.message)];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Tool Handler: Upload/Download files
     *
     * @param {FileUploadAndDownloadArgs} args - The arguments for the upload/download operation
     * @returns {WebMcpToolResponse} The response with operation result
     */
    WebMcpFileManager.prototype.handleFileUploadAndDownload = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var action, ids, _a, currentItems_1, invalidIds, downloadOutcome, error_2;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, , 7]);
                        action = args.action, ids = args.ids;
                        _a = action;
                        switch (_a) {
                            case 'upload': return [3 /*break*/, 1];
                            case 'download': return [3 /*break*/, 2];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        {
                            this.parent.uploadFiles();
                            return [2 /*return*/, this.message({
                                    action: 'manageFileUploadAndDownload',
                                    success: false,
                                    requiresUserInteraction: true,
                                    data: { action: 'upload' },
                                    message: 'Upload dialog opening requires a user gesture in the browser. Please invoke the upload workflow from the UI to continue.'
                                })];
                        }
                        _b.label = 2;
                    case 2:
                        if (!(ids && Array.isArray(ids) && ids.length > 0)) {
                            return [2 /*return*/, this.error('Download requires ids array with at least one item')];
                        }
                        currentItems_1 = this.getCurrentItems();
                        invalidIds = ids.filter(function (idValue) { return !_this.itemExistsById(idValue, currentItems_1); });
                        if (invalidIds.length > 0) {
                            return [2 /*return*/, this.message({
                                    action: 'manageFileUploadAndDownload',
                                    success: false,
                                    data: { action: 'download', filesProcessed: 0 },
                                    message: "Unable to download missing item id(s): " + invalidIds.join(', ')
                                })];
                        }
                        this.parent.downloadFiles(ids);
                        return [4 /*yield*/, this.waitForOperation('download', 2500)];
                    case 3:
                        downloadOutcome = _b.sent();
                        if (!downloadOutcome.success) {
                            return [2 /*return*/, this.message({
                                    action: 'manageFileUploadAndDownload',
                                    success: false,
                                    data: { action: 'download', filesProcessed: ids.length },
                                    message: downloadOutcome.message || "Download request for " + ids.length + " item(s) did not complete."
                                })];
                        }
                        return [2 /*return*/, this.message({
                                action: 'manageFileUploadAndDownload',
                                success: true,
                                data: { action: 'download', filesProcessed: ids.length },
                                message: "Downloaded " + ids.length + " file(s)"
                            })];
                    case 4: return [2 /*return*/, this.error("Unknown action \"" + action + "\" for manageFileUploadAndDownload")];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_2 = _b.sent();
                        return [2 /*return*/, this.error("Failed to handle file upload/download: " + error_2.message)];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Tool Handler: Navigate and open files
     *
     * @param {NavigateAndOpenFilesArgs} args - The arguments for the navigation/open operation
     * @returns {WebMcpToolResponse} The response with operation result
     */
    WebMcpFileManager.prototype.handleNavigateAndOpenFiles = function (args) {
        try {
            var action = args.action, fileId = args.fileId;
            switch (action) {
                case 'backward': {
                    var previousPath = this.parent.path;
                    var previousDepth = this.parent.pathNames ? this.parent.pathNames.length : 0;
                    this.parent.traverseBackward();
                    var currentPath = this.parent.path;
                    if (currentPath === previousPath && (this.parent.pathNames ? this.parent.pathNames.length : 0) === previousDepth) {
                        return this.message({
                            action: 'navigateAndOpenFiles',
                            success: false,
                            data: { action: 'backward', currentPath: previousPath },
                            message: 'Navigation did not change the current path.'
                        });
                    }
                    return this.message({
                        action: 'navigateAndOpenFiles',
                        success: true,
                        data: { action: 'backward', currentPath: currentPath },
                        message: 'Navigated to parent folder'
                    });
                }
                case 'openFile': {
                    if (!fileId) {
                        return this.error('openFile requires fileId parameter');
                    }
                    var item = this.findItemById(fileId);
                    if (!item) {
                        return this.message({
                            action: 'navigateAndOpenFiles',
                            success: false,
                            data: { action: 'openFile', fileId: fileId },
                            message: "Item \"" + fileId + "\" was not found in the current folder."
                        });
                    }
                    var previousPath = this.parent.path;
                    this.parent.openFile(fileId);
                    var currentPath = this.parent.path;
                    if (!item.isFile && currentPath === previousPath) {
                        return this.message({
                            action: 'navigateAndOpenFiles',
                            success: false,
                            data: { action: 'openFile', fileId: fileId, currentPath: currentPath },
                            message: 'Open request did not change the current path.'
                        });
                    }
                    return this.message({
                        action: 'navigateAndOpenFiles',
                        success: true,
                        data: { action: 'openFile', fileId: fileId, currentPath: currentPath },
                        message: item.isFile ? 'File opened' : 'Folder opened'
                    });
                }
                case 'refresh': {
                    this.parent.refreshFiles();
                    return this.message({
                        action: 'navigateAndOpenFiles',
                        success: true,
                        data: { action: 'refresh', currentPath: this.parent.path, filesCount: this.getCurrentItems().length },
                        message: 'File list refreshed'
                    });
                }
                default:
                    return this.error("Unknown action \"" + action + "\" for navigateAndOpenFiles");
            }
        }
        catch (error) {
            return this.error("Failed to navigate/open files: " + error.message);
        }
    };
    /**
     * Tool Handler: Filter and search files
     *
     * @param {FilterAndSearchFilesArgs} args - The arguments for the filter/search operation
     * @returns {WebMcpToolResponse} The response with operation result
     */
    WebMcpFileManager.prototype.handleSearchAndFilterFiles = function (args) {
        try {
            var filterData = args.filterData;
            if (filterData) {
                this.parent.filterFiles(filterData);
            }
            return this.message({
                action: 'searchAndFilterFiles',
                success: true,
                data: {
                    filterApplied: !!filterData,
                    matchCount: 0,
                    files: []
                },
                message: filterData ? 'Filter applied successfully' : 'Filter cleared'
            });
        }
        catch (error) {
            return this.error("Failed to filter files: " + error.message);
        }
    };
    /**
     * Tool Handler: Control UI elements
     *
     * @param {ControlUserInterfaceArgs} args - The arguments for the UI control operation
     * @returns {WebMcpToolResponse} The response with operation result
     */
    WebMcpFileManager.prototype.handleUserInterface = function (args) {
        try {
            var action = args.action, items = args.items;
            switch (action) {
                case 'enableMenu':
                    if (items && Array.isArray(items)) {
                        if (items.length === 0) {
                            return this.error('enableMenu requires at least one item');
                        }
                        this.parent.enableMenuItems(items);
                        return this.message({
                            action: 'manageUserInterface',
                            success: true,
                            data: { action: 'enableMenu', itemsAffected: items.length, items: items },
                            message: "Enabled " + items.length + " menu item(s)"
                        });
                    }
                    return this.error('enableMenu requires items array');
                case 'disableMenu':
                    if (items && Array.isArray(items)) {
                        if (items.length === 0) {
                            return this.error('disableMenu requires at least one item');
                        }
                        this.parent.disableMenuItems(items);
                        return this.message({
                            action: 'manageUserInterface',
                            success: true,
                            data: { action: 'disableMenu', itemsAffected: items.length, items: items },
                            message: "Disabled " + items.length + " menu item(s)"
                        });
                    }
                    return this.error('disableMenu requires items array');
                case 'enableToolbar':
                    if (items && Array.isArray(items)) {
                        if (items.length === 0) {
                            return this.error('enableToolbar requires at least one item');
                        }
                        this.parent.enableToolbarItems(items);
                        return this.message({
                            action: 'manageUserInterface',
                            success: true,
                            data: { action: 'enableToolbar', itemsAffected: items.length, items: items },
                            message: "Enabled " + items.length + " toolbar item(s)"
                        });
                    }
                    return this.error('enableToolbar requires items array');
                case 'disableToolbar':
                    if (items && Array.isArray(items)) {
                        if (items.length === 0) {
                            return this.error('disableToolbar requires at least one item');
                        }
                        this.parent.disableToolbarItems(items);
                        return this.message({
                            action: 'manageUserInterface',
                            success: true,
                            data: { action: 'disableToolbar', itemsAffected: items.length, items: items },
                            message: "Disabled " + items.length + " toolbar item(s)"
                        });
                    }
                    return this.error('disableToolbar requires items array');
                case 'closeDialog':
                    this.parent.closeDialog();
                    return this.message({
                        action: 'manageUserInterface',
                        success: true,
                        data: { action: 'closeDialog' },
                        message: 'Dialog closed'
                    });
                case 'refreshLayout':
                    this.parent.refreshLayout();
                    return this.message({
                        action: 'manageUserInterface',
                        success: true,
                        data: { action: 'refreshLayout' },
                        message: 'Layout refreshed'
                    });
                default:
                    return this.error("Unknown action \"" + action + "\" for manageUserInterface");
            }
        }
        catch (error) {
            return this.error("Failed to control UI: " + error.message);
        }
    };
    /**
     * Tool Handler: Select files in batch
     *
     * @param {SelectFilesInBatchArgs} args - The arguments for the batch selection operation
     * @returns {WebMcpToolResponse} The response with operation result
     */
    WebMcpFileManager.prototype.handleSelection = function (args) {
        try {
            var action = args.action;
            switch (action) {
                case 'selectAll': {
                    this.parent.selectAll();
                    var selectedFiles = this.parent.getSelectedFiles() || [];
                    if (selectedFiles.length === 0) {
                        return this.message({
                            action: 'manageSelection',
                            success: false,
                            data: { action: 'selectAll', filesSelected: 0 },
                            message: 'Selection did not update. No items were selected.'
                        });
                    }
                    return this.message({
                        action: 'manageSelection',
                        success: true,
                        data: { action: 'selectAll', filesSelected: selectedFiles.length },
                        message: "Selected all " + selectedFiles.length + " file(s)"
                    });
                }
                case 'clearSelection': {
                    this.parent.clearSelection();
                    var selectedFiles = this.parent.getSelectedFiles() || [];
                    if (selectedFiles.length !== 0) {
                        return this.message({
                            action: 'manageSelection',
                            success: false,
                            data: { action: 'clearSelection', filesSelected: selectedFiles.length },
                            message: 'Selection was not cleared.'
                        });
                    }
                    return this.message({
                        action: 'manageSelection',
                        success: true,
                        data: { action: 'clearSelection', filesSelected: 0 },
                        message: 'Selection cleared'
                    });
                }
                default:
                    return this.error("Unknown action \"" + action + "\" for manageSelection");
            }
        }
        catch (error) {
            return this.error("Failed to manage file selection: " + error.message);
        }
    };
    /**
     * Removes event listeners and cleanup.
     *
     * @returns {void} Nothing returned
     */
    WebMcpFileManager.prototype.destroy = function () {
        this.removeEventListener();
        if (this.webMcpAbortController) {
            this.webMcpAbortController.abort();
            this.webMcpAbortController = null;
        }
        this.parent = null;
    };
    /**
     * Returns module name for identification.
     *
     * @returns {string} The module name
     */
    WebMcpFileManager.prototype.getModuleName = function () {
        return 'webmcpfilemanager';
    };
    WebMcpFileManager.prototype.getCurrentItems = function () {
        var fileSystemItems = (this.parent.fileSystemData && Array.isArray(this.parent.fileSystemData)
            && this.parent.fileSystemData.length > 0)
            ? this.parent.fileSystemData.slice() : (this.parent.itemData || []);
        var items = fileSystemItems;
        return Array.isArray(items) ? items.slice() : [];
    };
    WebMcpFileManager.prototype.itemExistsById = function (idValue, items) {
        if (items === void 0) { items = this.getCurrentItems(); }
        return items.some(function (item) { return String(item.id) === String(idValue) || String(item.name) === String(idValue); });
    };
    WebMcpFileManager.prototype.itemNameExists = function (name, shouldValidateCurrentFolder, idToExclude) {
        var normalizedName = (name || '').trim().toLowerCase();
        if (!normalizedName) {
            return false;
        }
        var items = this.getCurrentItems();
        return items.some(function (item) {
            var itemName = (item && item.name) ? String(item.name).trim().toLowerCase() : '';
            if (shouldValidateCurrentFolder) {
                return itemName === normalizedName;
            }
            var sameItemId = String(item.id) !== String(idToExclude);
            return itemName === normalizedName && sameItemId;
        });
    };
    WebMcpFileManager.prototype.findItemById = function (idValue) {
        return this.getCurrentItems().find(function (item) {
            return String(item.id) === String(idValue) || String(item.name) === String(idValue);
        });
    };
    WebMcpFileManager.prototype.waitForOperation = function (action, timeoutMs, targetName, targetIds) {
        if (timeoutMs === void 0) { timeoutMs = 2500; }
        return __awaiter(this, void 0, void 0, function () {
            var startTime, _loop_1, this_1, state_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startTime = Date.now();
                        _loop_1 = function () {
                            var currentItems, createdItemName, renamedItemName, renameMatched, remainingIds;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        currentItems = this_1.getCurrentItems();
                                        if (action === 'download') {
                                            return [2 /*return*/, { value: { success: true, message: 'Download request initiated.' } }];
                                        }
                                        if (action === 'create' && targetName) {
                                            createdItemName = this_1.parent.createdItem && this_1.parent.createdItem.name ?
                                                String(this_1.parent.createdItem.name).trim().toLowerCase() : '';
                                            if (this_1.itemNameExists(targetName, true) || createdItemName === targetName.trim().toLowerCase()) {
                                                return [2 /*return*/, { value: { success: true, message: "Folder \"" + targetName + "\" exists." } }];
                                            }
                                        }
                                        if (action === 'rename' && targetName) {
                                            renamedItemName = this_1.parent.renamedItem && this_1.parent.renamedItem.name ?
                                                String(this_1.parent.renamedItem.name).trim().toLowerCase() : '';
                                            renameMatched = currentItems.some(function (item) {
                                                var itemName = item.name ? String(item.name).trim().toLowerCase() : '';
                                                return itemName === targetName.trim().toLowerCase();
                                            });
                                            if (renameMatched || renamedItemName === targetName.trim().toLowerCase()) {
                                                return [2 /*return*/, { value: { success: true, message: "Item renamed to \"" + targetName + "\"." } }];
                                            }
                                        }
                                        if (action === 'delete' && targetIds && targetIds.length > 0) {
                                            remainingIds = targetIds.filter(function (idValue) { return _this.itemExistsById(idValue, currentItems); });
                                            if (remainingIds.length === 0) {
                                                return [2 /*return*/, { value: { success: true, message: 'Delete operation completed.' } }];
                                            }
                                        }
                                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 50); })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 1;
                    case 1:
                        if (!(Date.now() - startTime < timeoutMs)) return [3 /*break*/, 3];
                        return [5 /*yield**/, _loop_1()];
                    case 2:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object")
                            return [2 /*return*/, state_1.value];
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, {
                            success: false,
                            message: "The " + action + " operation did not complete in time."
                        }];
                }
            });
        });
    };
    /**
     * Formats successful response in WebMCP standard format.
     *
     * @param {Record<string, string | number | boolean | object | null>} data - The data to format
     * @returns {WebMcpToolResponse} The formatted response
     */
    WebMcpFileManager.prototype.message = function (data) {
        return { content: [{ type: 'text', text: JSON.stringify(data) }] };
    };
    /**
     * Formats error response in WebMCP standard format.
     *
     * @param {string} text - The error text
     * @returns {WebMcpToolResponse} The formatted error response
     */
    WebMcpFileManager.prototype.error = function (text) {
        return { content: [{ type: 'text', text: text }], isError: true };
    };
    return WebMcpFileManager;
}());
export { WebMcpFileManager };
